import { AgreementEntity } from '../entities/agreement-entity';

export default class State {
  loaded = false;

  items: Array<AgreementEntity> = [];
}
